<div class="" id="totalpaidcardreport">

  <section id="cardapproval" class="why-us section-bg">
    <div class="container-fluid" data-aos="fade-up">
      <div class="container" data-aos="fade-in">
        <div class="section-title">
          <h2>Paid Cards</h2>
        </div>
      </div>


      <div class="row">

        <div class="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone No</th>
                <th scope="col">Reference Code</th>
                <th scope="col">Package</th>
                <th scope="col">Created Date</th>
                <th scope="col">Expiry Date</th>
                <th scope="col">Approval Stage</th>
                <th scope="col">Paid Status</th>

              </tr>
            </thead>
            <tbody *ngFor="let i of total_paid_card_details_todayreport">
            <tr *ngIf="i">
              <td>
                  <p>{{i[0]}}</p>
              </td>

              <td>
                <p>{{i[1]}}</p>
              </td>
              <td>
                <p>{{i[2]}}</p>
              </td>
              <td>
                <p>{{i[3]}}</p>
              </td>
              <td>
                <p>{{i[4]}}</p>
              </td>
              <td>
                <p>{{i[5]}}</p>
              </td>
              <td>
                <p>{{i[6]}}</p>
              </td>
              <td>
                <p>{{i[7]}}</p>
              </td>
              <td>
                <p>{{i[8]}}</p>
              </td>
            </tr>
          </tbody>

          </table>

      </div>
  </div>
  </div>
  </section>


  </div>
